document.addEventListener('DOMContentLoaded', function () {
  const dropHintPopup = document.getElementById('drop-hint-popup');
  const openTrigger = document.querySelector('.open-drop_hint_button__trigger');
  const closeButton = document.querySelector('.drop-hint-popup__close');
  const overlay = document.querySelector('.drop-hint-popup__overlay');


  if (openTrigger) {
    openTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (dropHintPopup) {
        // Lấy src của image trong drop-hint-popup__form__left
        const productImage = dropHintPopup.querySelector('.drop-hint-popup__product-image');
        const hiddenField = document.getElementById('hidden-1');
        if (productImage && hiddenField) {
          hiddenField.value = productImage.src;
        }
        dropHintPopup.classList.add('active');
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  if (dropHintPopup) {
    dropHintPopup.addEventListener('click', function (e) {
      if (e.target === dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dropHintPopup && dropHintPopup.classList.contains('active')) {
      dropHintPopup.classList.remove('active');
    }
  });




  const hintRecipientName = document.getElementById('hintRecipientName');
  const hintSenderName = document.getElementById('hintSenderName');
  let recipientInput = null;
  let senderInput = null;
  function findInputFields() {
    recipientInput = document.getElementById('118862-text-1');
    senderInput = document.getElementById('118862-text');

    if (recipientInput && !recipientInput.hasAttribute('data-hint-listener')) {
      recipientInput.setAttribute('data-hint-listener', 'true');
      recipientInput.addEventListener('input', updateRecipientName);
      recipientInput.addEventListener('keyup', updateRecipientName);
      recipientInput.addEventListener('change', updateRecipientName);
    }

    if (senderInput && !senderInput.hasAttribute('data-hint-listener')) {
      senderInput.setAttribute('data-hint-listener', 'true');
      senderInput.addEventListener('input', updateSenderName);
      senderInput.addEventListener('keyup', updateSenderName);
      senderInput.addEventListener('change', updateSenderName);
    }
  }

  function updateRecipientName() {
    if (hintRecipientName && recipientInput) {
      const value = recipientInput.value.trim();
      hintRecipientName.textContent = value || '_________';
    }
  }

  function updateSenderName() {
    if (hintSenderName && senderInput) {
      const value = senderInput.value.trim();
      hintSenderName.textContent = value || '_________';

    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        setTimeout(findInputFields, 100);
      }
    });
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  findInputFields();

});